import React, { useEffect, useRef } from "react";
import StockLocationController from "../../../../../controllers/StockLocationController";
import styles from "./ProductAssociationMessage.module.css";
import { useTranslation } from "react-i18next";

const ProductAssociationMessage = ({
  site,
  user,
  stockLocationScanned,
  setStockLocationScanned,
  productRescanned,
  setProductAssociationNotFound,
  scannedProducts,
  setScannedProducts,
  scannedStockedItemsQuantities,
  setScannedStockedItemsQuantities,
}) => {
  const { t } = useTranslation("stock");

  const _controller = useRef(null);

  useEffect(() => {
    _controller.current = new StockLocationController(user, site);
  }, []);

  const associateHandler = () => {
    // const currentProductAssociations = [
    //   ...stockLocationScanned.productAssociations,
    // ];

    const newAssociation = {
      min: 0,
      max: 0,
      product: productRescanned,
    };

    // updateStockLocation
    const callback = (error, updatedStockLocation) => {
      if (!error) {
        setStockLocationScanned(updatedStockLocation);
        setProductAssociationNotFound(false);
      } else {
        console.log("error:", error);
      }
    };

    let tempStockLocation = {
      ...stockLocationScanned,
    };

    let tempProductAssociations = [
      ...tempStockLocation.productAssociations,
      newAssociation,
    ];

    tempStockLocation.productAssociations = tempProductAssociations;

    _controller.current.updateStockLocation(tempStockLocation, callback);
  };

  const cancelHandler = () => {
    setProductAssociationNotFound(false);

    let tempArray1 = [...scannedProducts];
    let tempArray2 = [...scannedStockedItemsQuantities];

    if (tempArray1.length > 0) {
      tempArray1.splice(-1, 1);
      setScannedProducts(tempArray1);
    }

    if (tempArray2.length > 0) {
      tempArray2.splice(-1, 1);
      setScannedStockedItemsQuantities(tempArray2);
    }
  };
  return (
    <div className={styles.stockLocationOption}>
      <p className={styles.stockLocationOption__message}>
        {t("associateConfirmation")}{" "}
        <span className={styles.stockLocationOption__messageStyling}>
          {stockLocationScanned.barcode}
        </span>
        ?
      </p>
      <div className={styles.stockLocationOption__buttons}>
        <button
          className={[
            styles["stockLocationOption__button"],
            styles["stockLocationOption__button--create"],
          ].join(" ")}
          onClick={associateHandler}
        >
          {t("associateButtonLabel")}
        </button>
        <button
          className={[
            styles["stockLocationOption__button"],
            styles["stockLocationOption__button--cancel"],
          ].join(" ")}
          onClick={cancelHandler}
        >
          {t("cancelButtonLabel")}
        </button>
      </div>
    </div>
  );
};

export default ProductAssociationMessage;
